export default "__VITE_ASSET__Dq_fgd4V__"